import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";

export default function TermsOfService() {
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [termsOfService, settermsOfService] = useState([]);

  useEffect(() =>
  {
    window.scrollTo(0, 0);
    (async () => {
      let rawRouting = await API.get(
        config.api.termsOfService,
        {},
        { index: 1 }
      );
      settermsOfService(rawRouting[0]);
      setBusy(false);
    })();
    // eslint-disable-next-line
  }, [isBusy]);

  if (isBusy) return <Loading type="Oval" color="#FFBE03" className="loader" />;
  else
    return (
      <>
        <div className="section section-standart">
          <div class="section-content privacy-policy">
            {termsOfService?.desc &&
              termsOfService?.desc[lang] &&
              parse(termsOfService.desc[lang])}
          </div>
        </div>
      </>
    );
}
